const computeSigVehicleDeltas = (boughtTalents) => {
    const stats = {};
    const baseMods = [];
    const weaponQualities = {};
    let massive = false;
    (boughtTalents || []).forEach((t) => {
        const vc = t.data?.VehicleChanges;
        if (!vc) { return; }
        (vc.Stats || []).forEach((s) => {
            if (!s.Stat) { return; }
            const amt = (parseInt(s.Amount) || 0) * (s.PerRank === "true" ? (t.count || 1) : 1);
            if (amt) { stats[s.Stat] = (stats[s.Stat] || 0) + amt; }
        });
        (vc.WeaponQualities || []).forEach((wq) => {
            if (!wq.Key) { return; }
            const amt = (parseInt(wq.Amount) || 0) * (wq.PerRank === "true" ? (t.count || 1) : 1);
            if (amt) { weaponQualities[wq.Key] = (weaponQualities[wq.Key] || 0) + amt; }
        });
        if (vc.Massive === "true") { massive = true; }
        if (vc.BaseMod) { baseMods.push(vc.BaseMod); }
    });
    return { stats, baseMods, weaponQualities, massive };
};

const computeSigVehicleProjectSize = (boughtTalents) => {
    let total = 0;
    (boughtTalents || []).forEach((t) => {
        const size = t.data?.VehicleChanges?.ProjectSize;
        if (size) { total += (parseInt(size) || 0) * (t.count || 1); }
    });
    return total;
};

const reverseSigVehicleChanges = (vehicle) => {
    const led = vehicle.SigChoiceMods;
    if (!led) { return vehicle; }
    Object.keys(led.stats || {}).forEach((st) => {
        vehicle[st] = (parseInt(vehicle[st]) || 0) - led.stats[st];
    });
    (led.weaponQuals || []).forEach((rec) => {
        const list = vehicle.VehicleWeapons || [];
        let weap = list[rec.wi];
        if (!weap || (rec.wKey != null && weap.Key !== rec.wKey)) {
            weap = list.find((w) => w.Key === rec.wKey);
        }
        const q = weap && Array.isArray(weap.Qualities) && weap.Qualities.find((x) => x.Key === rec.Key);
        if (q) { q.Count = (parseInt(q.Count) || 0) - rec.amt; }
    });
    if (led.massive) { delete vehicle.Massive; }
    if (led.baseMods && led.baseMods.length && Array.isArray(vehicle.BaseMods)) {
        const texts = new Set(led.baseMods);
        vehicle.BaseMods = vehicle.BaseMods.filter((m) => !(m && texts.has(m.MiscDesc)));
    }
    delete vehicle.SigChoiceMods;
    return vehicle;
};

const applySigVehicleChanges = (vehicle, boughtTalents) => {
    reverseSigVehicleChanges(vehicle);
    const { stats, baseMods, weaponQualities, massive } = computeSigVehicleDeltas(boughtTalents);

    Object.keys(stats).forEach((st) => {
        vehicle[st] = (parseInt(vehicle[st]) || 0) + stats[st];
    });

    let massiveApplied = false;
    if (massive && !vehicle.Massive) { vehicle.Massive = 1; massiveApplied = true; }

    const weaponQuals = [];
    if (Object.keys(weaponQualities).length && Array.isArray(vehicle.VehicleWeapons)) {
        vehicle.VehicleWeapons.forEach((weap, wi) => {
            if (!Array.isArray(weap.Qualities)) { return; }
            Object.keys(weaponQualities).forEach((qk) => {
                const q = weap.Qualities.find((x) => x.Key === qk);
                if (q) {
                    q.Count = (parseInt(q.Count) || 0) + weaponQualities[qk];
                    weaponQuals.push({ wi, wKey: weap.Key, Key: qk, amt: weaponQualities[qk] });
                }
            });
        });
    }

    if (baseMods.length) {
        if (!Array.isArray(vehicle.BaseMods)) {
            vehicle.BaseMods = vehicle.BaseMods ? [vehicle.BaseMods] : [];
        }
        baseMods.forEach((text) => vehicle.BaseMods.push({ MiscDesc: text }));
    }

    const ledger = { stats: {}, baseMods, weaponQuals };
    if (massiveApplied) { ledger.massive = true; }
    Object.keys(stats).forEach((st) => { ledger.stats[st] = stats[st]; });
    if (Object.keys(ledger.stats).length || ledger.baseMods.length || ledger.weaponQuals.length || ledger.massive) {
        vehicle.SigChoiceMods = ledger;
    }
    return vehicle;
};

export { computeSigVehicleDeltas, computeSigVehicleProjectSize, reverseSigVehicleChanges };
export default applySigVehicleChanges;
